<template>
  <div class="buy">
    <p>你向</p>
    <p>{{this.$route.query.shopname}}</p>
    <p>购买</p>
    <div class="avator-wrapper">
      <div class="avator">
        <div class="image">
          <img :src="this.$route.query.goodsimg" alt>
        </div>
      </div>
    </div>
    <p class="name">{{this.$route.query.goodsname}}</p>
    <div class="btn" @click="buy">确认购买</div>
    <div class="motai" v-show="isMotail">
      <div class="title">{{message}}</div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      isMotail: false,
      message: ""
    };
  },
  created() {
    document.getElementsByTagName("title")[0].innerText = "我是谜520表白商店";
  },
  methods: {
    buy() {
      //购买人的信息
      axios
        .post(this.$interfaces.userBuyActivityLoveGoods, {
          userGuid: this.$store.state.userguid,
          token: this.$store.state.token,
          platform: this.getplatform(),
          ownerUserGuid: this.$store.state.otheruserguid, //店主id
          goodsId: this.$route.query.goodsId
        })
        .then(res => {
          // console.log(res);
          if (res.data.code == 200) {
            this.$router.push({
              path: "/complete",
              query: {
                id: res.data.data.id, //id
                name: res.data.data.name //用户名称
              }
            });
          } else {
            if (res.data.code == 400) {
              this.$router.push({ path: "/login" });
              return;
            }
            var code = res.data.code;
            if (code == 900005 || code == 900000 ||  code == 900001) {
              this.message = res.data.message;
              this.isMotail = true;
              setTimeout(() => {
                this.isMotail = false;
              }, 2000);
               return;
            }
            if (code == 500006) {
                this.message = "您的钻石不足请到我是谜app充值";
                this.isMotail = true;
                setTimeout(() => {
                  this.isMotail = false;
                }, 2000);
                return;
              }
          }
        });
    },
    getplatform() {
      var platform;
      var u = navigator.userAgent,
        app = navigator.appVersion;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      isiOS ? (platform = 2) : (platform = 1);
      return platform;
    },
  }
};
</script>
<style scoped>
.buy {
  width: 100%;
  height: 33.35rem;
  background: url("../../../assets/images/active/bg/buylist.png") 0 0 no-repeat;
  background-size: cover;
  padding-top: 6rem;
}
.buy .goback {
  font-size: 0.5rem;
  color: black;
  background: pink;
  opacity: 0.6;
  position: absolute;
  top: 1.25rem;
  left: 1.25rem;
}
p {
  font-size: 1.2rem;
  color: #ff4074;
  font-weight: 400;
  text-align: center;
}
.avator-wrapper {
  width: 5rem;
  height: 5rem;
  margin: 0 auto;
  margin-top: 1rem;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.avator-wrapper .avator .image {
  width: 3rem;
  height: 2.55rem;
  overflow: hidden;
  /* border-radius:100px; */
}
.avator-wrapper .avator .image img {
  width: 100%;
  height: 100%;
}
.buy .name {
  font-size: 0.7rem;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: rgba(117, 86, 98, 1);
  line-height: 0.7rem;
  margin: 1rem 0;
}

.buy .btn {
  margin: 0 1.375rem;
  width: 16rem;
  height: 3rem;
  line-height: 3rem;
  text-align: center;
  color: rgba(255, 255, 255 0.6);
  font-size: 1rem;
  background: url("../../../assets/images/active/login.png") 0 0 no-repeat;
  background-size: 100% 100%;
}
.buy .btn img {
  width: 100%;
  height: 100%;
}
.buy .motai {
  position: fixed;
  bottom: 20%;
  left: 23%;
  width: 11.25rem;
  height: 2.5rem;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 0.5rem;
  z-index: 9999;
}
.buy .motai .title {
  color: white;
  font-size: 0.75rem;
  width: 100%;
  height: 2.5rem;
  line-height: 2.5rem;
  text-align: center;
}
.buy .motai .close {
  color: white;
  font-size: 1rem;
  width: 100%;
  height: 2.5rem;
  line-height: 2.5rem;
}
</style>





// WEBPACK FOOTER //
// src/components/active/view/buy.vue